import React from 'react'
import { Link } from 'react-router-dom'

import logo from '../../../assets/images/positronic horizontal.png'

export default function () {
	return (
		<Link className="flex items-center space-x-2" to="/">
			<img
				src={logo}
				alt="Positronic Tech"
				className="h-14 object-contain"
			/>
		</Link>
	)
}
